import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import useCurrentSession from '@/utils/hooks/user/useCurrentSession';

import LinkBase from '@/components/base/LinkBase';
import LoaderPage from '@/components/base/Loader/LoaderPage';
import LayoutSignIn from '@/components/layouts/LayoutSignIn';
import LatestUpdates from '@/components/pages/signin/LatestUpdates';
import SignInForm from '@/components/pages/signin/SignInForm';

import { FORGOT_PASSWORD, SIGN_IN, SIGN_UP } from '@/routes/publicRoutes';

const SignIn = () => {
    const { t: tSignin } = useTranslation('signin');
    const { isLoading, user } = useCurrentSession({ isLoggedRedirect: true });

    if (isLoading || user) {
        return <LoaderPage />;
    }

    return (
        <LayoutSignIn>
            <SignInForm />
            <div className="flex items-center justify-center">
                <LinkBase
                    href={FORGOT_PASSWORD}
                    className="mt-3 text-center font-GMedium text-xs text-icoGray-500 underline">
                    {tSignin('forgot_your_password')}
                </LinkBase>
            </div>
            <p className="mt-10 text-center font-GSemiBold text-sm">
                {tSignin('not_registered_yet')}
                <LinkBase href={SIGN_UP} className="ml-1 text-icoBlue">
                    {tSignin('sign_up')}
                </LinkBase>
            </p>
            <div className="absolute bottom-10 right-10 hidden lg:block">
                <LatestUpdates />
            </div>
        </LayoutSignIn>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(SIGN_IN);

export default SignIn;
